<template>
  <span class='pl-15 pr-15 pb-5 fw-400 fs-12 lh-14' v-if='status' style='min-width: 121px'>
    <span class='dib w-8 h-8 br-p-50 pulse-green-item mr-5'></span> I'm Online Now
  </span>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import axios from 'axios'
import { onlineStatusLDURL } from '~/composables/api/apiDomain'
import {onBeforeRouteLeave} from "vue-router";

// export default {
//   name: 'LDOnlineStatus',
  const props = defineProps({
    expertID: {type: Number, default: 0}
  })
  // setup(props) {
    const status = ref(0)
    const statusID = ref()

    const onlineStatus = async () => {
      if(process.server) {
        return
      }
      if (props.expertID !== 0) {
        try {
          let resp = await axios.get(onlineStatusLDURL,{
            params: {
              id: props.expertID
            }
          })
          status.value = resp.data.online
        } catch (e) {
          console.log(e)
          throw new Error('onlineStatus error (LD online) : ', { cause: e })
        }
      }
    }

    const getOnlineStatus = () => {
      if(process.server) return
      statusID.value = setInterval(onlineStatus,10000)
    }

    onMounted(async () => {
      if(window.IS_BOT !== 1) {
        onlineStatus()
        getOnlineStatus()
      }
    })

    onBeforeRouteLeave(() => {
      if(process.server) return
      clearInterval(statusID.value)
    })

    defineExpose({
      status
    })

//     return {status}
//   }
// }
</script>

<style scoped>

</style>
